import PhotoPickerField from './photoPickerField';
import entityComposition from '../../common/classes/entityComposition';
export default entityComposition(PhotoPickerField, ['form', 'report', 'issue', 'formModal'], {
  userID: state => state.login.user.user_id
}, []);